import { z } from "zod";

export const FrequencyEnum = z.enum(["M", "W", "F", "4W", "Q", "A"]);

// Normalize incoming frequency values: map empty string/null/undefined to 'M'
const FrequencyField = z.preprocess(
  (v) => (v === "" || v === null || v === undefined ? "M" : v),
  FrequencyEnum,
);

export const MoneyFreq = z.object({
  value: z.coerce.number().min(0).default(0),
  frequency: FrequencyField,
  balance: z.coerce.number().min(0).default(0).optional(),
});

export const DebtField = z.object({
  value: z.coerce.number().min(0).default(0),
  balance: z.coerce.number().min(0).default(0).optional(),
  frequency: FrequencyField,
  category: z.string().default("").optional(),
});

const AboutYouSchema = z.object({
  customersEmploymentStatus: z.string().default("UNK"),
  partnersEmploymentStatus: z.string().default("UNK"),
  homeStatus: z.string().default(""),
  employmentTypeId: z.coerce.number().default(0),
  employmentTitleId: z.coerce.number().default(0),
  adults: z.coerce.number().min(0).default(0),
  childrenUnder16: z.coerce.number().min(0).default(0),
  children16to18: z.coerce.number().min(0).default(0),
  numberOfVehicles: z.coerce.number().min(0).default(0),
});

export const financialFormSchema = z.object({
  income: z.record(MoneyFreq),
  fixed: z.record(MoneyFreq),
  flexible: z.record(MoneyFreq),
  debts: z.record(DebtField),
  monthlySavingsAmount: z.coerce.number().min(0).default(0),
  fixedOther: z
    .array(
      z.object({
        label: z.string().default(""),
        amount: z.coerce.number().min(0).default(0),
        balance: z.coerce.number().min(0).default(0).optional(),
        frequency: FrequencyField,
      }),
    )
    .max(5)
    .default([]),
  aboutYou: AboutYouSchema,
  triggersAckCompleteFlexible: z.boolean().default(false).optional(),
});

export type FinancialFormValues = z.infer<typeof financialFormSchema>;
